module.exports = __webpack_public_path__ + "static/media/system-oto-modulesC-img.3ad31f10.png";